/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_No_Options_ErrorInputs */



/**
* | output |
* | --- |
* | "No export options selected." |
*
* @param {Audio_Description_Export_No_Options_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_no_options_error = /** @type {((inputs?: Audio_Description_Export_No_Options_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_No_Options_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune option d'exportation selectionnee.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es wurden keine Exportoptionen ausgewählt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna opzione di esportazione selezionata.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Параметры экспорта не выбраны.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay opciones de exportación seleccionadas.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未选择任何导出选项。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポート オプションが選択されていません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई निर्यात विकल्प नहीं चुना गया।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhuma opção de exportação selecionada.")
	return /** @type {LocalizedString} */ ("No export options selected.")
});